<template>
  <el-dialog
    title="订单费用"
    :visible.sync="visible"
    width="400px"
    @close="$emit('update:show', false)"
    @open="opened"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="订单" v-if="order">
        <label>{{ order.number }}</label>
      </el-form-item>
      <el-form-item label="费用金额" prop="amount">
        <el-input
          style="width:100%"
          size="small"
          v-model="model.amount"
          placeholder="请输入费用金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="费用类型" prop="type">
        <el-autocomplete
          style="width:100%"
          class="inline-input"
          v-model="model.type"
          :fetch-suggestions="queryTypeSearch"
          placeholder="费用类型"
          @select="handleSelectType"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="费用产生日期" prop="date">
        <el-date-picker
          style="width:100%"
          size="small"
          v-model="model.date"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submiting" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  createCustomerInvoice,
  updateCustomerInvoice,
  customerOrderList,
  createCustomerCollection,
  updateOrderCost,
  createOrderCost,
  orderCostTypes
} from '../service/getData'

export default {
  props: {
    model: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: null
    }
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {}
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        amount: [
          { required: true, message: '请输入费用金额', trigger: 'change' }
        ],
        type: [{ required: true, message: '请输入费用类型', trigger: 'change' }]
      },
      types: [],
      submiting: false
    }
  },
  created() {
    if (this.types.length == 0) {
      this.requestOrderCostTypes()
    }
  },
  methods: {
    async requestOrderCostTypes() {
      let res = await orderCostTypes()
      if (res.data.list) {
        this.types = res.data.list.map(item => {
          return {
            value: item
          }
        })
      }
    },
    opened() {
      if (this.types.length == 0) {
        this.requestOrderCostTypes()
      }
    },
    queryTypeSearch(query, cb) {
      console.log(this.types)
      cb(this.types)
    },
    handleSelectType(item) {
      this.model.type = item.value
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submiting = true
          this.model.amount = parseFloat(this.model.amount)
          if (this.model.id > 0) {
            let res = await updateOrderCost(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createOrderCost(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          return false
        }
      })
    }
  }
}
</script>